import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  orderDetails: null,
};

const labReportReUploadSlice = createSlice({
  name: "labReportReUpload",
  initialState,
  reducers: {
    initializeState(state, action) {
      state.loading = false;
      state.error = null;
      state.orderDetails = null;
    },
    initializeError(state, action) {
      state.error = null;
    },
    fetchOrderDetails(state, action) {
      state.loading = true;
    },
    fetchOrderDetailsSuccess(state, action) {
      state.orderDetails = action.payload.data.document;
      state.loading = false;
    },
    fetchOrderDetailsFailure(state, action) {
      state.loading = false;
    },
    updateReport(state, action) {
      state.loading = true;
    },
    updateReportSuccess(state, action) {
      state.loading = false;
      state.orderDetails = action.payload.data.document;
    },
    updateReportFailure(state, action) {
      console.log(action);
      state.loading = false;
      state.error = action.payload.message;
    },
  },
});

export const { actions, reducer, name: sliceKey } = labReportReUploadSlice;
